import {
    FETCH_ETAPAS, FETCH_OPERADORES,
    FETCH_PRODUCTION_STATISTICS_BY_STATION, RECEIVE_ETAPAS, RECEIVE_OPERADORES,
    RECEIVE_PRODUCTION_STATISTICS_BY_STATION,
    NEW_OPERADOR, NEW_OPERADOR_SUCCESS
} from "./actionTypes";
import axios from '../axiosApi';


export const dpFetchProductionStatisticsByStation =  () => ({
    type: FETCH_PRODUCTION_STATISTICS_BY_STATION
});

export const dpReceiveProductionStatisticsByStation = payload => ({
    type: RECEIVE_PRODUCTION_STATISTICS_BY_STATION,
    payload: payload
});

export const dpFetchEtapas =  () => ({
    type: FETCH_ETAPAS
});

export const dpReceiveEtapas = payload => ({
    type: RECEIVE_ETAPAS,
    payload: payload
});


export const dpFetchOperadores =  () => ({
    type: FETCH_OPERADORES
});

export const dpReceiveOperadores = payload => ({
    type: RECEIVE_OPERADORES,
    payload: payload
});

export const getProductionStatisticsByStation = () => {
    return async (dispatch, getState) => {
        dispatch(dpFetchProductionStatisticsByStation());
        let payload;


        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            const response1 = await axios.post(`/Stations/ProductionStatistics`, options1)
            payload = {
                error: false,
                result: "OK",
                data: response1.data
            }
            // payload = {
            //     "period": response1.data';
            // }
            // let options2 = {
            //     "Interval": {
            //         "Min": "2018-12-11",
            //         "Max": "2018-12-12"
            //     }
            // }
            // const response2 = await axios.post(`/Stations/ProductionStatistics`, options2)
            // payload = {
            //     ...payload,
            //     "before": response2.data
            // }
            // let options3 = {
            //     "Interval": {
            //         "Min": "2018-12-07",
            //         "Max": "2018-12-08"
            //     }
            // }
            // const response3 = await axios.post(`/Stations/ProductionStatistics`, options3)
            // payload = {
            //     ...payload,
            //     "benchmark": response3.data
            // }
        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                data: []
            }
        }
        finally {
            dispatch(dpReceiveProductionStatisticsByStation(payload));
        }
    }
};


export const getEtapas = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getEtapas Mock");
            return;
        }



        dispatch(dpFetchEtapas());
        let payload;


        const { periodMin, periodMax, beforeperiodMin, beforeperiodMax, benchperiodMin, benchperiodMax } = getState().filter;

        try {
            let options1 = {
                "Interval": {
                    "Min": periodMin,
                    "Max": periodMax
                },
                "IntervalComparasion": {
                    "Min": beforeperiodMin,
                    "Max": beforeperiodMax
                },
                "IntervalBenchmark": {
                    "Min": benchperiodMin,
                    "Max": benchperiodMax
                }
            }
            const response1 = await axios.get(`/etapas`)
            payload = {
                error: false,
                result: "OK",
                data: response1.data
            }

        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                data: []
            }
        }
        finally {
            dispatch(dpReceiveEtapas(payload));
        }
    }
};

export const getOperadores = () => {

    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        if (bMock) {
            console.log("getOperadores Mock");
            return;
        }


        dispatch(dpFetchOperadores());
        let payload;

        console.log("getOperadores.");

        try {

            const response1 = await axios.get(`/operadors`)
            payload = {
                error: false,
                result: "OK",
                data: response1.data
            }

        }
        catch(e) {
            payload = {
                error: true,
                result: "FAIL",
                data: []
            }
        }
        finally {
            dispatch(dpReceiveOperadores(payload));
        }
    }
};

export const dpNewOperador = () => ({
    type: NEW_OPERADOR
});

export const dpNewOperadorSuccess = payload => ({
    type: NEW_OPERADOR_SUCCESS,
    payload: payload
});

export const postOperador = (operador) => {
    return async dispatch => {
        dispatch(dpNewOperador());
        let payload;
        try {
            const response = await axios.post(`/operadors`, operador);
            payload = response.data;
        }
        catch(e) {
            payload = { error: true };
        }
        finally {
            dispatch(dpNewOperadorSuccess(payload));
            dispatch(getOperadores());
        }
    }
};
